import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  f,
  ls,
//  BarC,
  BoxC,
  BtnC,
  GridC,
  IptC,
  LblC,
  SrlC,
  //_cv_51_Mz,
  _cv_51___Ti,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as _cv_51___Ti from "./_cv_51___Ti";
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    frcUdt: () => void,
  }
}) => {

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                  cr.c(_cv_51___Ti.S, {
                    key: -10,
                    sPz: pz.sPz,
                    frcUdt: pz.sPz.udt,
                  })
                ]
              },
              {
                oClds: [
                ]
              },
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [
/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'cttCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    mkrCz: {
                      textz: {
                        pfx: _lblz.msgz.topz.mkr,
                      }
                    },
                    msgCz: {
                      textz: {
                        pfx: _lblz.msgz.topz.msg,
                      }
                    }
                  },
                ]
              },
            }),
*/
            cr.c(SrlC.V, {
              key: -30,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(_cv_51___Ti.L, {
                  key: -10,
                  sPz: pz.sPz,
                  frcUdt: pz.sPz.udt,
                })

              ],
            }),

            cr.c(_cv_51___Ti.B, {
              key: -40,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                onPrsBack: () => {
                  cr.moveTo({
                    pageName: 'icvHomeS40Rz',
                  });
                }
              }
            })

          ]
        })

      ]
    })
  );
};
